import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth.jsx";
import { LogOut, LayoutDashboard, ListChecks, PlusCircle, BookOpen, Wallet } from "lucide-react";

export default function Layout({ children }) {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();

  const items = [
    { to: "/", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
    { to: "/entries", label: "Transactions", icon: ListChecks, testid: "nav-transactions" },
    { to: "/ledgers", label: "Ledgers", icon: BookOpen, testid: "nav-ledgers" },
    ...(user?.salary_access ? [{ to: "/salary", label: "Salary & Compensation", icon: Wallet, testid: "nav-salary" }] : []),
  ];

  return (
    <div className="min-h-screen bg-white text-slate-900 flex flex-col">
      <header className="border-b border-slate-200 bg-white sticky top-0 z-30">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-2" data-testid="brand-link">
            <div className="w-8 h-8 rounded-lg bg-[#0055FF] flex items-center justify-center text-white font-bold">T</div>
            <div className="hidden sm:block">
              <div className="font-display font-bold text-slate-900 leading-tight">Tai Sang</div>
              <div className="text-[11px] text-slate-500 leading-tight">Money Entry System</div>
            </div>
          </Link>

          <nav className="flex items-center gap-1">
            {items.map(({ to, label, icon: Icon, testid }) => {
              const active = loc.pathname === to;
              return (
                <Link
                  key={to}
                  to={to}
                  data-testid={testid}
                  className={`px-3 sm:px-4 h-10 rounded-lg flex items-center gap-2 text-sm font-medium transition-colors ${
                    active ? "bg-[#0055FF] text-white" : "text-slate-700 hover:bg-slate-100"
                  }`}
                >
                  <Icon size={16} />
                  <span className="hidden sm:inline">{label}</span>
                </Link>
              );
            })}
            <button
              onClick={() => nav("/entry")}
              data-testid="nav-new-entry-btn"
              className="ml-1 px-3 sm:px-4 h-10 rounded-lg flex items-center gap-2 text-sm font-semibold bg-slate-900 text-white hover:bg-slate-800 transition-colors"
            >
              <PlusCircle size={16} />
              <span className="hidden sm:inline">New Entry</span>
            </button>
          </nav>

          <div className="flex items-center gap-3">
            <div className="text-right hidden md:block">
              <div className="text-sm font-semibold text-slate-900" data-testid="user-name">{user?.name}</div>
              <div className="text-[11px] text-slate-500 uppercase tracking-wider">{user?.role}</div>
            </div>
            <button
              onClick={logout}
              data-testid="logout-btn"
              className="w-10 h-10 rounded-lg flex items-center justify-center text-slate-600 hover:bg-slate-100 transition-colors"
              title="Sign out"
            >
              <LogOut size={18} />
            </button>
          </div>
        </div>
      </header>

      <main className="flex-1 max-w-6xl w-full mx-auto px-4 sm:px-6 py-6 sm:py-10">
        {children}
      </main>
    </div>
  );
}
